<template>
  <a
    href="#0"
    class="hover:bg-light-gray-400 focus:bg-light-gray-400 block no-underline transition duration-300">
    <slot />
  </a>
</template>
